import { startTransition, StrictMode } from "react"
import { hydrateRoot } from "react-dom/client"
import { HydratedRouter } from "react-router/dom"
import "show-open-file-picker/polyfill"

import("@iyk/vf-observability/react").then(({ monitoring }) => {
  if (window.SENTRY_CONFIG) {
    monitoring.init(window.SENTRY_CONFIG)
  }
})

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>,
  )
})
